export const intlConfig = {
  key: 'ru-RU',
  locale: 'ru-RU',
  messages: [],
  onError: () => {},
}
